
const VueUtils = require('../../../modules/vue-utils');


document.addEventListener('DOMContentLoaded', () => {

    if (!document.querySelector('html.my-account.my-details')) {
        return;
    }

    const $locationInput = VueUtils.getRef('favourite-location-search');

    if (!$locationInput) {
        throw 'Unable to find location input field!';
    }

    let preselected = $locationInput.$el.dataset.values;

    if (preselected) {
        preselected = JSON.parse(preselected);
    }

    if (preselected && preselected.length > 0) {
        for (const location of preselected) {
            $locationInput.injectExternalResult(location[0], location[1]);
            $locationInput.toggleSelectionFromValue(location[0]);
        }
    }
});
